export default "__VITE_ASSET__CJvOHh44__"